/**
 * Tworzy okno z animacją ładowania
 */
export class LoadingDialog {

    /**
     * @param {object} options
     */
    constructor(options = {}) {
        this.options = {
            message: '',
            blur: true,
            blurTarget: '#page-content',
            blurClass: 'blur-8',
            container: 'body',
            spinnerColor: 'dark',
            spinnerSize: 3,
            style: {},
            ...options,
        };

        this.$modal = jQuery('<div>', {class: 'new-order-modal'});
        this.$wrapper = jQuery('<div>', {class: 'new-order-modal-wrapper'});
        this.$container = jQuery('<div>', {class: 'new-order-modal-container card shadow'});
        this.$body = jQuery('<div>', {class: 'new-order-modal-body card-body'});
        this.$messageContainer = jQuery('<div>');
        this.$spinner = POLKURIER.createSpinner({
            center: true,
            color: this.options.spinnerColor,
            size: this.options.spinnerSize,
            class: 'mt-2'
        });

        this.$wrapper.append([
            this.$modal.append([
                this.$container.append([
                    this.$body.append([
                        this.$spinner,
                        this.$messageContainer
                    ])
                ])
            ])
        ]);

        this.$target = jQuery(this.options.container);
        this.$blurTarget = jQuery(this.options.blurTarget);
        this.setMessage(this.options.message);
    }

    show() {
        if (this.options.blur === true) {
            this.$blurTarget.addClass(this.options.blurClass);
        }
        this.$target.append(this.$wrapper);
        this.$wrapper
            .css(this.options.style)
            .css({top: 0});
        this.$container.addClass('pk-puff-in');
        return this;
    }

    hide() {
        this.$container.removeClass('pk-puff-in');
        this.$container.addClass('pk-puff-out');
        setTimeout(() => {
            this.$wrapper.remove();
            this.$container.removeClass('pk-puff-out');
        }, 300);
        this.$blurTarget.removeClass(this.options.blurClass);
        return this;
    }

    setMessage(message) {
        this.options.message = String(message);
        this.$messageContainer
            .html(this.options.message)
            .toggleClass('mb-3', this.options.message.length > 0);
        return this;
    }

    appendMessage(message) {
        this.setMessage(this.options.message + String(message));
        return this;
    }

    appendElement(html) {
        this.$messageContainer.append(html);
        return this;
    }

}
